import { z } from 'zod';

const isFormerUserSchema = z.object({
  former: z.number(),
});

export const validateIsFormerUserResponseData = (value: unknown) => isFormerUserSchema.parse(value);
